<template>
  <div>
    <section-title
      content="Documentos de Dispensa"
      :has-line="true"
      style="margin-top: 40px;"
    />
    <validation-observer ref="dispenseDocumentsRef" novalidate tag="form">
      <div v-for="(exemptionFile, i) in innerExemptionFiles" :key="i">
        <callout class-main="mb-2 py-3" :has-toggle="false">
          <div class="col-12 d-flex justify-content-between">
            <div>
              <span class="exemption-file__title">Documento</span>
              <p>{{ exemptionFile.name }}</p>
            </div>
            <div>
              <CustomFileInput
                v-model="exemptionFile.file"
                accept=".pdf"
                add-text="Presione aquí para añadir Documento"
                :attachment-id="exemptionFile.fileId"
                display-style="normal"
                :name="exemptionFile.fileName"
                :on-download="() => {}"
              />
            </div>
          </div>
        </callout>
        <error
          v-if="
            showExemptionError &&
              exemptionFile.required &&
              !exemptionFile.file &&
              !exemptionFile.fileId
          "
          class="mb-3"
          message="El documento es requerido."
          variant="no-border"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import Callout from 'custom-callout';
import CustomFileInput from 'CustomFileInput';
import Error from 'custom-error';

export default {
  name: 'DispenseDocuments',
  components: {
    SectionTitle,
    Callout,
    CustomFileInput,
    Error,
  },
  props: {
    innerExemptionFiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showExemptionError: false,
    };
  },
  computed: {
    areExemptionFilesValid() {
      const requiredFiles = this.innerExemptionFiles.filter((x) => x.required);
      const isValid = requiredFiles.reduce(
        (acum, next) => !!next.file && acum,
        true
      );

      return isValid;
    },
  },
  methods: {
    async validateDocuments() {
      this.showExemptionError = true;
      return this.areExemptionFilesValid;
    },
  },
};
</script>
